import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Header from './components/site/Header';
import Hero from './components/site/Hero';
import About from './components/site/About';
import Programs from './components/site/Programs';
import Gallery from './components/site/Gallery';
import Teachers from './components/site/Teachers';
import News from './components/site/News';
import Footer from './components/site/Footer';
import TeachingMaterials from './components/site/TeachingMaterials';
import AuthPage from './pages/auth/AuthPage';
import RestrictedPage from './pages/auth/RestrictedPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminLayout from './components/admin/AdminLayout';
import DashboardPage from './pages/admin/DashboardPage';
import ResourcePage from './pages/admin/ResourcePage';
import ProfilePage from './pages/admin/ProfilePage';

const Home = () => (
  <div className="App bg-sky-soft">
    <Header />
    <main>
      <Hero />
      <About />
      <Programs />
      <Gallery />
      <Teachers />
      <News />
      <TeachingMaterials />
    </main>
    <Footer />
    <Toaster />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<AuthPage mode="login" />} />
        <Route path="/register" element={<AuthPage mode="register" />} />
        <Route path="/akses-terbatas" element={<RestrictedPage />} />
        <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
          <Route index element={<DashboardPage />} />
          <Route path=":resource" element={<ResourcePage />} />
          <Route path="profil" element={<ProfilePage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
